module.exports = __webpack_public_path__ + "static/media/laugh-beam.b210c9d4.svg";